function getENAEPDomain() {
  const location = window.location.origin;
  const domain = location.includes("localhost")
    ? "https://enaep.dev26.npdng.org"
    : `${location}`;
  return domain;
}
function getDomain() {
  const location = window.location.origin;
  const domain = location.includes("localhost")
    ? "http://localhost:3000/download-center/resources/"
    : location;
  return domain;
}
function getApiDomain() {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const domain = hostname.includes("localhost")
    ? `https://enaep.dev26.npdng.org`
    : `${protocol}//${hostname}`;
  return domain;
}
function isLocalhost() {
  const hostname = window?.location.hostname;
  return hostname?.includes("localhost");
}
function formatDate(date: Date, time = false) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (time) {
    const sec = d.getSeconds();
    const milisec = d.getMilliseconds();
    const hour = d.getHours();
    return [year, month, day, hour, sec, milisec].join("-");
  } else {
    return [month, day, year].join("-");
  }
}

export { getENAEPDomain, getApiDomain, isLocalhost, formatDate, getDomain };

export function downloadPDF(source: string) {
  const windowFeatures = `width=${window.screen.width / 2},height=${
    window.screen.height / 2
  }`;
  window.open(source, source, windowFeatures);
}
